import * as React from 'react';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import RegisterCard from './RegisterCard';
import Register from './Register';
import BasicCard from './skewCard';
import Login from './Login';
import { useNavigate } from 'react-router-dom';
import WebcamCapture  from './RegisterStep2'
import { Button } from '@mui/material';
import './Ardss.css';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TabComponent(props) {
  const navigate=useNavigate();
  const {id,search}=props

  const handleLogin=()=>{
    navigate({
      pathname: "/login/",
      search: search,
    })  
  }
  const handleRegister=()=>{
    navigate({
      pathname: "/register/",
      search:search,
    })  
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs  aria-label="tabs example">
         {id==0? <Tab style={{fontSize:"1.2rem", fontWeight:"700"}} label="Register " onClick={handleRegister} {...a11yProps(id)} />:""}
          {id==1?<Tab className='tb' style={{fontSize:"1.2rem", fontWeight:"700",margin: '30% 0 0 0'}} label="Sign In " onClick={handleLogin} {...a11yProps(id)} />:""}
          {id==2?<Tab style={{fontSize:"1.2rem", fontWeight:"700"}} label="Register Step 2 "   />:""}
        </Tabs>
      </Box>
      <TabPanel value={id} index={0} >
         <Register/>
      </TabPanel>
      <TabPanel value={id} index={1}>
         <Login/>
      </TabPanel>

      <TabPanel value={id} index={2}>
      <WebcamCapture />
      </TabPanel>
      {id==0?<Typography style={{fontSize:"1.2rem"}}>If already registered <br/><Button variant='contained' onClick={()=>{handleLogin()}} style={{backgroundColor: "#06213F", cursor:"pointer", fontSize:".9rem"}}>CLICK HERE</Button></Typography>:""}
      {id==1?<Typography className='to' style={{fontSize:"1.2rem",padding:'16px'}}>Haven't registered yet  <br/><Button variant='contained' onClick={()=>{handleRegister()}} style={{backgroundColor: "#06213F", cursor:"pointer", fontSize:".9rem",marginTop:'2%'}}>REGISTER NOW!</Button></Typography>:""}
      {id==2?<Typography style={{fontSize:"1.2rem"}}>If already registered <br/><Button variant='contained' onClick={()=>{handleLogin()}} style={{backgroundColor: "#06213F", cursor:"pointer", fontSize:".9rem"}}>CLICK HERE</Button></Typography>:""}

    </Box>
  );
}